import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Custom fontSize tokens use the `text-*` prefix. Without registering them,
 * tailwind-merge treats them as text-color utilities and can drop real colors
 * (e.g. `text-brand-foreground` + `text-body-md` → only `text-body-md`).
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'headline-xl',
            'headline-lg',
            'headline-md',
            'body-lg',
            'body-md',
            'body-sm',
            'label-md',
          ],
        },
      ],
      rounded: [{ rounded: ['pill'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
